import { message } from "antd";
import api from "./api";

const handleError = (error) => {
  const message =
    error.response?.data?.DisplayMessage ||
    error.response?.data?.Message ||
    error.message ||
    "Something went wrong";
  throw new Error(message);
};

export const getIRNList = async (from, to) => {
  try {
    const response = await api.get(`/InwardReceipt/getIRNList/${from}/${to}`);
    return response?.data || [];
  } catch (error) {
    handleError(error);
  }
};

export const getPeriodsApi = async (from, to) => {
  try {
    const response = await api.get(`/Period/getperiods`);
    return response?.data || [];
  } catch (error) {
    handleError(error);
  }
};

export const getStoresByUserId = async () => {
  try {
    const response = await api.get(`/Store/getStoreByUserID`);
    return response?.data || [];
  } catch (error) {
    handleError(error);
  }
};

export const getIRNTransactionByStore = async (storeId) => {
  try {
    const response = await api.get(
      `/InwardReceipt/getIRNTransactionByStore/${storeId}`
    );
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};

export const getAllPosApi = async (from, to,status) => {
  try {
    const response = await api.get(`/PurchaseOrder/getallpolist/${from}/${to}/${status}`);
    if (response?.data?.IsSuccess === true && response?.data?.Data===null) {
      message.error(response?.data?.DisplayMessage || "Failed to fetch PO list");
    }else{
      message.success(response?.data?.DisplayMessage || "PO list fetched successfully");
    }
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};

export const getPoDetail = async (receivedFrom, poNumber, storeCode) => {
  try {
    const encodedPoNumber = encodeURIComponent(poNumber);
    const response = await api.get(
      `/InwardReceipt/getPoDetail/${receivedFrom}/${encodedPoNumber}/${storeCode}`
    );
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};

export const getSettingsApi = async (id) => {
  try {
    const response = await api.get(`/Setting/${id}`);
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};
export const createIRN = async (formData) => {
  try {
    const response = await api.post("/InwardReceipt/createIRN", formData);
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};

export const uploadDocApi = async (file, onProgress) => {
  try {
    const data = new FormData();

    data.append("FileName", file?.name.split(".")[0]); // name without extension
    data.append("File", file); // <-- REAL binary file

    const response = await api.post("/FileUpload/blob/upload", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: (progressEvent) => {
        const percent = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        onProgress(percent);
      },
    });

    return response?.data?.Data;
  } catch (error) {
    handleError(error);
  }
};
export const downloadDocApi = async (name) => {
  try {
    const response = await api.get(`/FileUpload/blob/download?fileName=${name}`
    //   , {
    //   responseType: "blob",
    // }
  );
    return response?.data?.Data;
  } catch (error) {
    handleError(error);
  }
};
export const printDetailByIrnApi = async (irn) => {
  try {
    const response = await api.get(
      `/InwardReceipt/getPrintDetailByIRNNO/${encodeURIComponent(irn)}`
    );
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};
